import { FormProvider } from 'react-hook-form'

import { useInternationalStepperContainer } from './useInternationalStepperContainer'
import { Stepper } from '../../../../../../../../components/Stepper'
import { Step } from '../../../../../../../../components/Stepper/Step'
import { InternationalStepForm } from './InternationalStepForm'
import { InternationalBankStepForm } from './InternationalBankStepForm'
import { type ExpertDomain } from '../../../../../../../../types/domain/expert-domain'

type InternationalStepperContainerProps = {
  expert?: ExpertDomain
}

export const InternationalStepperContainer = ({
  expert,
}: InternationalStepperContainerProps) => {
  const {
    form,
    currentStep,
    isExpertInternationalDataSubmitting,
    setCurrentStep,
    handleSubmit,
    handleCancel,
  } = useInternationalStepperContainer(expert)

  return (
    <FormProvider {...form}>
      <Stepper currentStep={currentStep}>
        <Step index={0}>
          <InternationalStepForm
            isSubmitting={isExpertInternationalDataSubmitting}
            onCancel={handleCancel}
            onSubmit={() => setCurrentStep(1)}
          />
        </Step>

        <Step index={1}>
          <InternationalBankStepForm
            isSubmitting={isExpertInternationalDataSubmitting}
            onCancel={handleCancel}
            onSubmit={handleSubmit}
          />
        </Step>
      </Stepper>
    </FormProvider>
  )
}
